import {
  Radio,
  FormGroup,
  InputLabel,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import ageRatings from 'utils/ageRatings';
import { ageRatingByTargetAudience } from 'constants/fields';
import { Controller } from 'react-hook-form';
import { useEffect, useMemo } from 'react';
import { BpCheckedIcon, BpIcon } from './styles';
import { orderTargetAudiencesKeys, sortByAudienceAge } from 'utils/fields';

export const AgeRatingField = ({ control, watch, viewFields, setValue }) => {
  const selectedAgeRating = watch('ageRating');
  const selectedAudienceValues = watch('targetAudiences');

  const youngestSelectedAge = useMemo(() => {
    // Getting [0] cause value always sort by youngest age
    // If 2+ targetAudiences is checked is needed allow items based in youngest age value
    return selectedAudienceValues?.sort(sortByAudienceAge)?.[0];
  }, [selectedAudienceValues]);

  const isOnlyLRating = useMemo(
    () => selectedAudienceValues?.length === orderTargetAudiencesKeys?.length,
    [selectedAudienceValues]
  );

  useEffect(() => {
    const isEnabladByAge =
      ageRatingByTargetAudience?.[youngestSelectedAge]?.includes(
        selectedAgeRating
      );

    if (
      selectedAgeRating &&
      isOnlyLRating &&
      !['L', 'AL'].includes(selectedAgeRating)
    ) {
      setValue('ageRating', null);
    }

    if (selectedAgeRating && !isEnabladByAge) {
      setValue('ageRating', null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnlyLRating, selectedAgeRating, youngestSelectedAge]);

  return (
    <FormGroup className="mb-3" controlId="formName">
      <InputLabel className="form-label" htmlFor="name">
        Classificação
      </InputLabel>
      <Controller
        name="ageRating"
        control={control}
        defaultValue={null}
        rules={{
          required: true,
        }}
        render={({ field, fieldState: { error, isTouched } }) => {
          return (
            <RadioGroup
              id="video-age-rating"
              aria-labelledby="radio-buttons-group-label"
              style={{
                justifyContent: 'space-around',
                display: 'flex',
                flexDirection: 'row',
                width: 160,
              }}
              {...field}>
              {ageRatings.map((ageRating, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}>
                  <FormControlLabel
                    key={ageRating.acronym}
                    value={ageRating.acronym}
                    style={{ width: '45%', marginRight: 5 }}
                    control={
                      <Radio
                        disableRipple
                        color="default"
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                      />
                    }
                    aria-invalid={error ? 'true' : 'false'}
                    disabled={(() => {
                      const isEnabladByAge = (
                        isOnlyLRating
                          ? ['L', 'AL']
                          : ageRatingByTargetAudience?.[youngestSelectedAge]
                      )?.includes(ageRating.acronym);

                      return viewFields || !isEnabladByAge;
                    })()}
                  />
                  <InputLabel
                    className="form-label classification-label"
                    htmlFor="name"
                    style={{ backgroundColor: ageRating.color }}>
                    {ageRating.description}
                  </InputLabel>
                </div>
              ))}
              {isTouched && !field.value ? (
                <div
                  style={{
                    textWrap: 'nowrap',
                  }}
                  className="text-danger">
                  <span>{'O campo é obrigatório!'}</span>
                </div>
              ) : null}
            </RadioGroup>
          );
        }}
      />
    </FormGroup>
  );
};
